/* eslint-disable react/prop-types */
import { TextField } from "@mui/material";

export default function BasicTextField({
  labelText,
  value,
  setValue,
  isError = false,
  errorMsg = "Incorrect entry.",
}) {
  return (
    <TextField
      className="intelligent-profile-input"
      fullWidth
      size="small"
      id="website-input"
      label={value === "" ? "" + labelText : ""}
      variant="outlined"
      color="ochre"
      error={isError}
      helperText={isError ? errorMsg : ""}
      InputLabelProps={{
        shrink: false,
        // sx: {
        //   left: "20%",
        //   right: "20%",
        //   textAlign: "center",
        // },
      }}
      InputProps={{
        sx: {
          // borderRadius: 3,
          backgroundColor: "#F6F6F6",
          borderColor: "#F6F6F6",
        },
        inputProps: {
          // style: { textAlign: "center" },
        },
      }}
      onChange={setValue}
    />
  );
}
